import { useNavigate } from 'react-router';

import useSharedCardActions from './useSharedCardActions';

import type { GeneratorFunction } from './types';

const useNextSessionActions = (): GeneratorFunction => {
  const { handleClick } = useSharedCardActions();
  const navigate = useNavigate();

  return ({ card }) => {
    if (card.isSessionToday && card.session?.location) {
      // Prefer the server-derived kind field (R2); fall back to the legacy slug
      // string for any payload predating the kind field rollout.
      const isChemistryCall =
        card.session.kind === 'chemistry' ||
        card.session.slug === 'chemistry-call';

      return [
        {
          buttonProps: isChemistryCall
            ? { color: 'primary', variant: 'contained' }
            : {
                color: 'info',
              },
          label: 'Join session',
          onClick: () => {
            handleClick({ card, label: 'Join session', shouldUpdate: false });
            window.open(card.session?.location as string);
          },
        },
      ];
    }

    const buttonLabel = card.isSessionToday ? 'View session' : 'Post a note';
    return [
      {
        buttonProps: { color: 'info' },
        label: buttonLabel,
        onClick: () => {
          handleClick({ card, label: buttonLabel, shouldUpdate: false });
          navigate(`/m/sessions/${card.session?.id}`);
        },
      },
    ];
  };
};

export default useNextSessionActions;
